module.exports = __webpack_public_path__ + "static/media/wellness.575c4f3f.jpg";